module.exports = __webpack_public_path__ + "img/notice_continue.42ec14fc.png";